import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { guest: true },
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true, title: '仪表盘' },
  },
  {
    path: '/collections',
    name: 'Collections',
    component: () => import('../views/Collections.vue'),
    meta: { requiresAuth: true, title: '数据模型' },
  },
  {
    path: '/collections/:id',
    name: 'CollectionDetail',
    component: () => import('../views/CollectionDetail.vue'),
    meta: { requiresAuth: true, title: '模型详情' },
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue'),
    meta: { requiresAuth: true, title: '用户管理' },
  },
  {
    path: '/tenants',
    name: 'Tenants',
    component: () => import('../views/Tenants.vue'),
    meta: { requiresAuth: true, title: '租户管理' },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/Settings.vue'),
    meta: { requiresAuth: true, title: '系统设置' },
  },
  {
    path: '/api-keys',
    name: 'ApiKeys',
    component: () => import('../views/ApiKeys.vue'),
    meta: { requiresAuth: true, title: 'API Key 管理' },
  },
  {
    path: '/files',
    name: 'Files',
    component: () => import('../views/Files.vue'),
    meta: { requiresAuth: true, title: '文件管理' },
  },
  {
    path: '/quotas',
    name: 'Quotas',
    component: () => import('../views/Quotas.vue'),
    meta: { requiresAuth: true, title: '配额管理' },
  },
  {
    path: '/metadata',
    name: 'Metadata',
    component: () => import('../views/Metadata.vue'),
    meta: { requiresAuth: true, title: '元数据' },
  },
  {
    path: '/sync',
    name: 'Sync',
    component: () => import('../views/Sync.vue'),
    meta: { requiresAuth: true, title: '数据同步' },
  },
  {
    path: '/workflow',
    name: 'Workflow',
    component: () => import('../views/Workflow.vue'),
    meta: { requiresAuth: true, title: '工作流管理' },
  },
  {
    path: '/content',
    name: 'ContentManagement',
    component: () => import('../views/ContentManagement.vue'),
    meta: { requiresAuth: true, title: '内容管理' },
  },
  {
    path: '/roles',
    name: 'Roles',
    component: () => import('../views/Roles.vue'),
    meta: { requiresAuth: true, title: '角色管理' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const isAuthenticated = !!token

  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - Geekron CMS` : 'Geekron CMS'

  // 需要认证的路由
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login')
    return
  }

  // 访客路由（已登录不能访问）
  if (to.meta.guest && isAuthenticated) {
    next('/')
    return
  }

  next()
})

// 导航完成后滚动到顶部
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
